import {
  federatedIssuerAllowlistTerraformLine,
  installedFederatedIssuers,
  normalizeFederatedIssuers,
} from "@p0security/integrations-agentic-shared/terraform";
import { IdentityProviderComponents } from "@p0security/integrations-identity-provider-shared";
import type { FrontendInstaller } from "@p0security/integrations-installer";
import { Typography } from "@p0security/ui";

const { Text } = Typography;

export const identityProviderInstaller: FrontendInstaller<
  typeof IdentityProviderComponents
> = {
  components: {
    provider: {
      instructions: (context, _id, item) => {
        const { issuer } = item;
        // The identity provider's issuer is required and is collected on the
        // initial creation step, before an item can ever reach this later
        // (stage) step — so it should always be set here.
        if (!issuer) {
          throw new Error(
            "Identity provider reached the Terraform step with no issuer set"
          );
        }

        const installedIssuers = installedFederatedIssuers(context.config);
        const issuers = normalizeFederatedIssuers([
          ...installedIssuers,
          issuer,
        ]);

        return {
          help: (
            <>
              Update the line setting federatedIssuerAllowlist in this
              gateway&apos;s Terraform:
            </>
          ),
          commands: {
            iac: [
              {
                header: "Update your agentic gateway resource block",
                command: federatedIssuerAllowlistTerraformLine(issuers),
              },
            ],
          },
        };
      },
      preamble: () => (
        <div>
          <p>Defines a trust root for JWT-authenticated agents.</p>
          <p>
            Agents are federated into P0-managed identities. The federated
            subject is determined by the federating token&apos;s JWT claims. It
            is the first available of:
          </p>
          <ul>
            <li>
              <Text code>external_sub</Text> &ndash; If present
            </li>
            <li>
              <Text code>email</Text> &ndash; If present, and if{" "}
              <Text code>email_verified</Text> is <Text code>true</Text>
            </li>
            <li>
              <Text code>sub</Text> &ndash; Otherwise
            </li>
          </ul>
        </div>
      ),
      items: {},
    },
  },
};
